module.exports = __webpack_public_path__ + "static/media/siteLogo.94a2bb90.svg";